export default __webpack_public_path__ + "static/media/space_part3.5757873c.png";